import { Injectable } from '@angular/core';
import {AuthHttp} from '../../../user/services/auth/http/auth-http.service';
import {environment} from '../../../../../environments/environment';
import {FieldOption} from '../../../form-renderer/interfaces/FieldOption';

@Injectable()
export class DatasourceService {
    private headers = new Headers({'Content-Type': 'application/json'});
    private datasourceUrl = 'datasource';

    private cache: { [key: string]: FieldOption[]} = {};

  constructor(private http: AuthHttp) { }


    public getList() {
        const url = `${environment.baseUrl}${this.datasourceUrl}`;
        return this.http
            .get(url, {})
            .toPromise()
            .then(response => {
                return response.json();
            })
            .catch(this.handleError);
    }

  /**
   * Flushes the cache object
   */
  public flushCache() {
    this.cache = {};
  }


  public getDataSource(dataSource: string): Promise<FieldOption[]> {

    if (this.cache[dataSource])
      return Promise.resolve(this.cache[dataSource]);


    const url = `${environment.baseUrl}${this.datasourceUrl}/${dataSource}`;
    return this.http
      .get(url, {})
      .toPromise()
      .then(response => response.json())
      .then(options => this.cache[dataSource] = options)
      .catch(this.handleError);
  }


    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/form-builder/services/datasource/datasource.service.ts